import { Controller } from "react-hook-form";

import { ImageUpload } from "../../Inputs";
import { InputImageUploadProps } from "./InputImageUpload.types";
import { useEffect, useRef } from "react";
import { useDisabledField } from "../HookForm/HookForm.context";

export function InputImageUpload({
  disabled,
  form,
  rule,
  name,
  ...props
}: InputImageUploadProps) {

  const imageUploadRef = useRef<HTMLDivElement | null>();
  const isDisabled = useDisabledField(name);

  useEffect(() => {
    if (form.formState.isSubmitting) {
      const errorKeys = Object.keys(form.formState.errors);
      if (errorKeys.indexOf(name) === 0) {
        imageUploadRef.current?.scrollIntoView?.();
      }
    }
  }, [form.formState.isSubmitting]);


  return (
    <Controller
      control={form.control}
      rules={rule}
      name={name}
      render={({ field, fieldState }) => {
        const isError = !!fieldState.error;
        const errorMessage =
          fieldState.error?.message?.toString() ||
          (rule?.required === true ? 'Field cannot be empty' : undefined);
        return (
          <ImageUpload
            {...props}
            onChangeImage={(_) => field.onChange(_)}
            onDelete={()=>{field.value=undefined; form.setValue(name,undefined)}}
            helperText={isError ? errorMessage : props.helperText}
            required={!!rule?.required}
            disabled={isDisabled || disabled}
            value={field.value}
            error={isError}
            ref={(ref) => {
              imageUploadRef.current = ref;
              field.ref(ref);
            }}
          />
        );
      }}
    />
  );
}